import { useLocation } from "react-router-dom";
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import useFirestore from "shared/hooks/useFirestore";
import { ChangeEvent, useEffect, useState } from "react";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface student{
    name:string,
    tel:string,
    id:string,
    pw:string,
    pw_re:string,
    email:string,
    address:string,
    address_detail:string,
    school:string,
    birth:string,
    shuttle:boolean,
    join_date:string,
    parent_name:string,
    parent_tel:string,
    level:string,
    fee:string,
    status: 'active' | 'suspended' | 'graduated'
}



const useStudentRegister = () => {
    const randomNumber = generateRandomNumber();
    const { createAccount } = useFirebaseAuth();
    const id = useLocation().state;
    const { writeFirestore, readFirestoreOneDoc, updateFirestore, deleteFirestore } = useFirestore();
    const {getBranchId} = useGetBranchId();
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucced] = useState(false);
    const [isDuplicated, setIsDuplicated] = useState(null);
    const [isOpenPasswordModal, setIsOpenPasswordModal] = useState(false);
    const [isOpenDuplicatedModal, setIsOpenDuplicatedModal] = useState(false);
    const [isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal] = useState(false)
    const [isOpenDateModal, setIsOpenDateModal] = useState(false);
    const [isOpenNullModal, setIsOpenNullModal] = useState(false);
    const [studentInputs, setStudentInputs] = useState<student>({
        name:"",
        tel:"",
        id:"",
        pw:"toss" + randomNumber,
        pw_re:"toss" + randomNumber,
        email:"",
        address:"",
        address_detail:"",
        school:"",
        birth:"",
        shuttle:false,
        level:"1",
        join_date:"",
        parent_name:"",
        parent_tel:"",
        fee:"0",
        status: 'active'
    })

    useEffect(() => {
        if(id){
            getData();
        }
        // eslint-disable-next-line
    }, [id])

    function generateRandomNumber() {
        return Math.floor(1000 + Math.random() * 9000);
      }
    


    const getData = async() => {
        const data = await readFirestoreOneDoc("User/Auth/Student", id).then(res => {
            if(res.exists()){
                return res.data();
            }else{
                return null;
            }
        })

        if(data){
            setStudentInputs({
                name:data.name,
                tel:data.tel,
                id:data.id,
                pw:data.pw,
                pw_re:data.pw_re,
                email:data.email || "",
                address:data.address || "",
                address_detail:data.address_detail || "",
                school:data.school || "",
                join_date:data.join_date || "",
                parent_name:data.parent_name || "",
                parent_tel:data.parent_tel || "",
                birth:data.birth || "",
                level:data.level,
                shuttle:data.shuttle,
                fee:data.fee,
                status: data.status || 'active'
            })
        }
    }

    const formatDateString = (value: string): string => {
        const cleanedValue = value.replace(/[^\d]/g, '');
        let formattedDate = cleanedValue;
        if (cleanedValue.length >= 4) {
          formattedDate = `${cleanedValue.slice(0, 4)}-${cleanedValue.slice(4, 6)}`;
        }
        if (cleanedValue.length >= 6) {
          formattedDate = `${formattedDate}-${cleanedValue.slice(6, 8)}`;
        }
        return formattedDate;
      };

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        if(name === "shuttle"){
            const permission = (value === 'true');
            setStudentInputs({
                ...studentInputs,
                "shuttle":permission
            })
        }else{
            setStudentInputs({
                ...studentInputs,
                [name]:value
            })
        }
        if(name === "join_date" || name === "birth"){
            const formattedDate = formatDateString(value);
            setStudentInputs({
                ...studentInputs,
                [name]:formattedDate
            })
        }
    }

    const dateRegxCheck = (date:string) => {
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        if(regex.test(date)) {
            return true;
        }
        return false;
    }

    const onSaveButtonClick = () => {
        if(id){
            update();
        }else{
            register();
        }
    }


    const register = async() => {
        const name = studentInputs.name.trim();
        const id = studentInputs.id.trim();
        const pw = studentInputs.pw.trim();
        const pw_re = studentInputs.pw_re.trim();
        const tel = studentInputs.tel.trim();
        const email = studentInputs.email.trim();
        const address = studentInputs.address.trim();
        const address_detail = studentInputs.address_detail.trim();
        const school = studentInputs.school.trim();
        const parent_name = studentInputs.parent_name.trim();
        const parent_tel = studentInputs.parent_tel.trim();
        const join_date = studentInputs.join_date.trim();
        const level = studentInputs.level.trim();
        const shuttle = studentInputs.shuttle;
        const fee = parseInt(studentInputs.fee);
        const birth = studentInputs.birth.trim();
        if(!(id && pw && pw_re && name && parent_tel && parent_name && join_date)){
            setIsOpenNullModal(true);
            return;
        }
        if(isDuplicated || isDuplicated === null){
            setIsOpenDuplicatedModal(true);
            return;
        }
        if(pw !== pw_re){
            setIsOpenPasswordModal(true);
            return;
        }
        if(!dateRegxCheck(join_date)){
            setIsOpenDateModal(true);
            return;
        }
        const res = await createAccount(`${id}@toss.kr`, pw);
        if(res === null){
            setIsError(true);
            return;
        }

        const branch_id = await getBranchId();

        const student_data = {
            id:id,
            pw:pw,
            register_date:new Date(),
            name:name,
            tel:tel,
            email:email,
            address:address,
            address_detail:address_detail,
            branch_id:branch_id,
            school:school,
            join_date:join_date,
            unpaied:0,
            parent_name:parent_name,
            level:level,
            parent_tel:parent_tel,
            shuttle:shuttle,
            birth:birth,
            fee:fee,
            status: 'active'
        }
        writeFirestore("User/Auth/Log", res.uid, student_data).then(res => {
            if(res){
                setIsSucced(true);
            }
        })
        writeFirestore("User/Auth/Student", res.uid, student_data).then(res => {
            if(res){
                setIsSucced(true);
            }
        })
    }

    const update = () => {
        const name = studentInputs.name.trim();
        const tel = studentInputs.tel.trim();
        const email = studentInputs.email.trim();
        const address = studentInputs.address.trim();
        const address_detail = studentInputs.address_detail.trim();
        const school = studentInputs.school.trim();
        const parent_name = studentInputs.parent_name.trim();
        const parent_tel = studentInputs.parent_tel.trim();
        const shuttle = studentInputs.shuttle;
        const fee = parseInt(studentInputs.fee);
        const level = studentInputs.level.trim();
        const join_date = studentInputs.join_date.trim();
        const birth = studentInputs.birth.trim();
        if(!(name && parent_tel && parent_name && join_date)){
            setIsOpenNullModal(true);
            return;
        }
        if(!dateRegxCheck(join_date)){
            setIsOpenDateModal(true);
            return;
        }
    
        const update_data = {
            name:name,
            tel:tel,
            email:email,
            address:address,
            address_detail:address_detail,
            school:school,
            parent_name:parent_name,
            parent_tel:parent_tel,
            shuttle:shuttle,
            join_date:join_date,
            fee:fee,
            birth:birth,
            level:level,
            status: studentInputs.status
        }

        updateFirestore("User/Auth/Student", id, update_data).then(res =>{
            if(res){
                setIsSucced(true);
            }
        })
    }

    const onDeleteClickHandler = async() => {
        deleteFirestore(`User/Auth/Student`, id).then(res => {
          if(res){
            setIsOpenDeleteSucceedModal(true);
          }
        })
    }


    return {studentInputs, onChange, onSaveButtonClick, isError, setIsError, isSucceed, setIsDuplicated, 
        isOpenPasswordModal, setIsOpenPasswordModal, isOpenDuplicatedModal, setIsOpenDuplicatedModal,
        isOpenNullModal, setIsOpenNullModal, isOpenDateModal, setIsOpenDateModal,
        isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal, onDeleteClickHandler
    }
}

export default useStudentRegister;